/**
 * Rótulo do `breveRelato` que quem enviou a notificação escreveu. O texto deixa claro que o assunto
 * é a versão do remetente, não uma conclusão da Arbitralis — por isso precisa ser idêntico no
 * dashboard e no composer da resposta.
 */
export const ROTULO_ASSUNTO_INFORMADO = 'Assunto informado por quem enviou';
